<template>
  <span id="multiselect" style="width:200px;display: inline-block">
      <a-input type="text" ref="text" v-model="checkedName" :placeholder="name" @click="$refs.text.blur();showSelect = !showSelect;$event.stopPropagation()" />
      <div v-show="showSelect" @click="$event.stopPropagation()">
        <a-input type="text" v-model="filterWords" placeholder="搜索"/>
        <ul>
          <li v-show="filterWords == ''"><input type="checkbox" :checked="isCheckAll" @click="checkAll">&nbsp;全部</li>
          <li v-for="item in list" :key="item.id" v-show="item.name.indexOf(filterWords)!=-1 || filterWords == ''">
            &nbsp;<input type="checkbox" :name="Math.random()" v-model="checkedData" :value="item.id">&nbsp;<span v-text="item.name"></span>
          </li>             
        </ul>
      </div>
  </span>
</template>

<script>

import './index.less'

export default {
  name:'multiselect',
  props: ["list","name"],
  data:function(){
  	return {
  	  filterWords:"",
      showSelect:false,
      checkedData:[],
      isCheckAll:false,
      checkedName:""
  	}        
  },
  mounted:function(){
    document.addEventListener("click",this.close)
    this.$watch("checkedData",function(){
      this.checkedName = ""
      for (var j = 0; j < this.list.length; j++) {
        for (var i = 0; i < this.checkedData.length; i++) {
          if(this.checkedData[i] == this.list[j].id){
            this.checkedName = this.checkedName + this.list[j].name + "，"
          }
        }
      }
      this.$emit('change',this.checkedData)
    })
  },
  methods:{
    close:function(){
      this.showSelect = false
    },
    checkAll:function(){
        this.isCheckAll = !this.isCheckAll
      if (this.isCheckAll){
          this.checkedData = []
          this.list.forEach(item=>{
            this.checkedData.push(item.id)
          })
      } else {
          this.checkedData = []
      }
    }
  },
  watch:{
    checkedName:function (val) {
      if (!val){
        this.checkedData = []
      }
    },
    'checkedData.length':function (val) {
      if (val===0 || (val<this.list.length)){
        this.isCheckAll = false
      }
    }
  }
}
</script>